import { createApi } from '@reduxjs/toolkit/query/react';
import { API_BASEPATH_DISCOVERY } from '@/config/env.config';
import { createBaseQueryWithAuth } from '../baseQueryWithAuth';

export const discoveryApi = createApi({
	reducerPath: 'discoveryApi',
	tagTypes: ['projects'],
  baseQuery: createBaseQueryWithAuth(API_BASEPATH_DISCOVERY),
  endpoints: () => ({}),
});